import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { tokens } from "../../../../../../theme";

import Text from "../../../../../../components/theme/text/Text";

import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RelationWebshopIntegrationCard } from "../../../../../../components/global/cards/other/WebshopIntegrationCard";
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import { useGetIntegratorsQuery } from "../../../../../../newapi/webshop/integratorSlice";
import { ReactComponent as EtailizeLogo } from '../../../../../../styles/svg/etailize.svg';
import { ReactComponent as ProductflowLogo } from '../../../../../../styles/svg/productflow.svg';

import MpAddIntegrator from "../../../../../../components/global/ModalsProgression/MpAddIntegrator/MpAddIntegrator";
import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";
import SidepanelLoader from "../../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../../utils/permissions";
import ShLabel from "../../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../../components/theme/skeleton/ShLabelSkeleton";
import { SalesChannelIntegratorCard, WarehouseIntegratorCard } from "../../../../../../components/global/cards/other/IntegratorCard";

const SpIntegratorDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpIntegratorDetails/SpIntegratorDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);
    const {t} = useTranslation();

    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_integrator")}</Shbutton>
            )}
        </ButtonGroup>
    );
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [config, setConfig] = useState({"all_credentials": true});
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WEBSHOPCREDENTIALS_MANAGE])
    );

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };


    const [integratorId, setIntegratorId] = useState();
    const integratorIdRef = useRef(integratorId);
    
    const getIntegratorDetails = (params) => {
        if (!params) return;
    
        const newIntegratorId = parseInt(params.row.id);
        // Only update state if the webshopCredentialsId has actually changed
        if (integratorIdRef.current !== newIntegratorId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setIntegratorId(newIntegratorId);
            integratorIdRef.current = newIntegratorId; // Update the ref to the new value
        }
        setIsExtended(true);
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);
    
    const columns = [
        {field: "name", headerName: t("integrator") , flex:2, cellClassName: "integrator", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <>
                <Box sx={{ paddingRight: '10px' }}>
                    {cellValues.row.type === "etailize" ? <EtailizeLogo width={30} height={30}/> : null}
                    {cellValues.row.type === "productflow" ? <ProductflowLogo  width={30} height={30}/> : null}
                </Box>
                <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{cellValues.value}</Text>
                </>
            )
        }},
        ...isFulfilment ? [{field: "relation", headerName: t("relation") , flex:2, cellClassName: "relation", renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Text>{cellValues.value?.name}</Text>
            )
        }}] : [],
        {field: "webshopcredentials", headerName: t("channels") , flex:2, cellClassName: "channels", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text>{cellValues.value?.length ?? 0} {t("channels")}</Text>
            )
        }},
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const labelColor = params.row.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey";
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelColor}>
                      {t(params.row.state)}
                    </ShLabel>
                  );
              }
        },
        {field: "createdAt", headerName: t("created_at") , flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let date = new Date(cellValues.row.createdAt).toLocaleDateString(i18n.language);

            return (
                <Text>{date}</Text>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <WarehouseIntegratorCard 
                        skeleton={cellValues.row.skeleton ?? false} 
                        {...cellValues.row}
                        onClick={() => getIntegratorDetails(cellValues)}
                    />
                )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetIntegratorsQuery}
                config={config}
                gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>} 
                title={t("integrators")}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns}
                onRowClick={getIntegratorDetails}>
            </ShDataGrid2>

            <MpAddIntegrator onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>
            
            {spLoading && 
                <SpIntegratorDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    integratorId={integratorId}              
                /> 
            }
        </Box>
    )
};

export default All;